import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pillarArticles } from '@/mocks/articles';

export default function PillarSection() {
  const { t } = useTranslation();

  return (
    <section id="pillars" className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-stone-900 md:text-3xl">
            {t('pillar.title')}
          </h2>
          <p className="mt-3 text-sm text-stone-500 md:text-base">{t('pillar.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {pillarArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-stone-200 bg-white transition-colors hover:border-emerald-300"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-white/90 px-2.5 py-1 text-xs font-semibold text-emerald-700">
                  <i className="ri-article-line"></i>
                  Guide
                </div>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-semibold leading-snug text-stone-900">
                  {article.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-stone-500">
                  {article.description}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-emerald-600 transition-colors group-hover:text-emerald-700">
                  {t('pillar.readMore')}
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}